import http  from "./httpClient";

export interface DirectBoss {
  id: number;
  name?: string;
  description?: string;
  boss: {
    id: number;
    person: {
      firstName: string;
      lastName: string;
      secondLastName: string;
      curp?: string;
    };
  };
  employees: Array<{
    id: number;
    person: {
      firstName: string;
      lastName: string;
      secondLastName: string;
    };
  }>;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDirectBossDto {
  description?: string;
  bossId: number;
  employeeIds: number[];
  isActive?: boolean;
}

export interface UpdateDirectBossDto {
  description?: string;
  bossId?: number;
  employeeIds?: number[];
  isActive?: boolean;
}

export interface DirectBossResponse {
  results: DirectBoss[];
  total: number;
}

export const fetchDirectBosses = async (params?: string): Promise<DirectBossResponse> => {
  try {
    const response = await http.get(`/direct-boss${params || ''}`);
    
    // Si la respuesta es un array directo, lo convertimos al formato esperado
    if (Array.isArray(response.data)) {
      return {
        results: response.data,
        total: response.data.length
      };
    }
    
    // Si ya tiene la estructura correcta, la devolvemos
    return response.data;
  } catch (error) {
    console.error('Error fetching direct bosses:', error);
    // Devolver estructura vacía en caso de error
    return {
      results: [],
      total: 0
    };
  }
};

export const fetchDirectBossById = async (id: number): Promise<DirectBoss> => {
  const response = await http.get(`/direct-boss/${id}`);
  return response.data;
};

export const createDirectBoss = async (data: CreateDirectBossDto): Promise<DirectBoss> => {
  const response = await http.post('/direct-boss', data);
  return response.data;
};

export const updateDirectBoss = async (id: number, data: UpdateDirectBossDto): Promise<DirectBoss> => {
  const response = await http.patch(`/direct-boss/${id}`, data);
  return response.data;
};

export const deleteDirectBoss = async (id: number): Promise<{ message: string }> => {
  const response = await http.delete(`/direct-boss/${id}`);
  return response.data;
};

export const fetchDirectBossesByBossId = async (bossId: number): Promise<DirectBoss[]> => {
  const response = await http.get(`/direct-boss/boss/${bossId}`);
  return response.data;
};

export const fetchDirectBossesByEmployeeId = async (employeeId: number): Promise<DirectBoss[]> => {
  const response = await http.get(`/direct-boss/employee/${employeeId}`);
  return response.data;
};

export const checkIfDirectBoss = async (partnerId: number): Promise<{ isDirectBoss: boolean; directBossCount: number }> => {
  try {
    const response = await http.get(`/direct-boss/check-boss/${partnerId}`);
    return response.data;
  } catch (error) {
    return { isDirectBoss: false, directBossCount: 0 };
  }
};

export interface CollaboratorBossLookup {
  employee: {
    id: number;
    person: {
      firstName: string;
      lastName: string;
      secondLastName?: string;
      curp?: string;
    };
    candidate?: {
      branch?: { id: number; name: string };
      vacancy?: { position?: { name: string } };
      shift?: { name: string };
    };
  };
  hasDirectBoss: boolean;
  directBoss: DirectBoss | null;
  isDirectBoss: boolean;
  bossAssignments: DirectBoss[];
  teamCount: number;
}

export const lookupCollaboratorDirectBoss = async (
  employeeId: number
): Promise<CollaboratorBossLookup> => {
  const response = await http.get(`/direct-boss/lookup/${employeeId}`);
  return response.data;
};
